<template>
  <div class="bg-gradient-primary all-page">
    <div class="container">
      <!-- Outer Row -->
      <div class="row justify-content-center">
        <div class="col-xl-5 col-lg-12 col-md-9 pt-5 mt-5">
          <div class="card o-hidden border-0 shadow-lg my-5">
            <div class="card-body p-0">
              <!-- Error message -->
              <div
                class="alert text-center alert-danger formatted-text"
                role="alert"
                v-show="error"
              >
                {{ this.error }}
              </div>
              <!-- Nested Row within Card Body -->
              <div class="row bg-image">
                <!-- <div class="col-lg-6 d-none d-lg-block bg-login-image"></div> -->
                <div class="col-lg-12">
                  <div class="p-5">
                    <div class="text-center">
                      <img src="@/assets/logo-evisa-blue.png" />
                    </div>
                    <br />
                    <br />
                    <br />
                    <div v-if="!error" class="text-center">
                      <h1 class="h4 text-gray-900 mb-4">
                        Veuillez patienter un instant...
                      </h1>
                    </div>
                    <form v-if="error" class="user" autocomplete="off">
                      <!-- @submit.prevent="handleSubmit" -->
                      <!-- <div class="form-group">
                        <input
                          type="email"
                          class="form-control form-control-user"
                          :class="{ 'is-invalid': submitted && !email }"
                          id="email"
                          v-model="email"
                          aria-describedby="emailHelp"
                          placeholder="Votre adresse email"
                        />
                        <div
                          v-show="submitted && !email"
                          class="invalid-feedback"
                        >
                          Email requis
                        </div>
                      </div> -->
                      <!-- <div class="form-group">
                        <input
                          type="password"
                          class="form-control form-control-user"
                          :class="{ 'is-invalid': submitted && !password }"
                          id="password"
                          v-model="password"
                          placeholder="Votre mot de passe"
                        /> -->
                      <!-- <div
                          v-show="submitted && !password"
                          class="invalid-feedback"
                        >
                          Mot de passe requis
                        </div> -->
                      <!-- </div> -->

                      <!-- <button class="btn btn-primary btn-user btn-block">
                        CONNEXION
                      </button> -->
                      <!-- <hr /> -->
                      <div class="text-center">
                        <button
                          class="btn btn-primary btn-user btn-block"
                          @click="toMobileId"
                          type="button"
                        >
                          CLIQUEZ ICI POUR VOUS AUTHENTIFIER
                        </button>
                      </div>
                    </form>
                    <!-- <div class="text-center">
                      <a class="small" href="forgot-password.html"
                        >Mot de passe oublié?</a
                      >
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LOGIN_MOBILEID, FETCH_LOGED_USER } from "@/store/actions.type";
// import ApiService from "@/helpers/api";
import { FAILED_AUTH_MESSAGE, FAILED_MESSAGE } from "@/helpers/messages";
import { SET_LOADING } from "@/store/mutations.type";
import { mapState } from "vuex";
import JwtService from "@/helpers/jwt";

export default {
  name: "Callback",
  data() {
    return {
      submitted: false,
      error: "",
      MobileIdUrl:
        "https://tx-pki.gouv.bj/trustedx-authserver/oauth/main-as?" +
        "redirect_uri=https://bo.evisa.bj/authentication/callback&client_id=evisang&" +
        "response_type=code&acr_values=urn:gob:authentication:flow:mobile&scope=urn:gob:basic:profile&prompt=login",
    };
  },
  async mounted() {
    await this.handleSubmit();
  },
  computed: {
    ...mapState(["loading"]),
  },
  methods: {
    handleSubmit() {
      this.submitted = true;

      let code = this.$route.query.code;

      console.log("code", code);

      if (!code) {
        this.error = `${FAILED_MESSAGE}`;
        return;
      }

      this.$store.commit(SET_LOADING, true);

      this.$store
        .dispatch(LOGIN_MOBILEID, {
          code,
          grant_type: "password",
          client_id: "91a6ee93-2958-495c-90f2-7c3c8132dbbb",
          client_secret: "UuqFx0AYMcpQABgjumpRP9BcKWEhpDepiexqlFbz",
        })
        .then(() => {
          //ApiService.setHeaders();
          //console.log("Je suis rentré dans then")
          this.$store
            .dispatch(FETCH_LOGED_USER)
            .then(() => {
              //this.$router.push({ name: "home" });
              window.location.href = "/";
            })
            .catch(() => {
              JwtService.destroyToken();
              // this.error = `${FAILED_MESSAGE}`;
              this.$router.push({
                name: "login",
                params: { error: `${FAILED_MESSAGE}` },
              });
              // this.$router.push({ name: "login" });
            })
            .finally(() => {
              this.$store.commit(SET_LOADING, false);
            });
        })
        .catch(() => {
          //console.log("Je suis rentré dans error");
          // this.error = `${FAILED_AUTH_MESSAGE}  ${error}`;
          this.$store.commit(SET_LOADING, false);
          this.$router.push({
            name: "login",
            params: { error: `${FAILED_AUTH_MESSAGE}` },
          });
        });
      // .finally(() => {
      //   this.$store.state.auth.loading = false;
      // });
    },
    toMobileId() {
      window.location.href = this.MobileIdUrl;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";
.all-page {
  height: 100vh;
  display: flex;
  // align-items: center;
  background-color: $base-color;
  background-image: none;
}

// .bg-image {
//   padding-left: 50px;
// }
</style>
